import { AnalyticsOptions } from 'owa-analytics';

export default function getMiniAnalyticsOptions(): AnalyticsOptions {
    return {
        ariaTenantTokens: [
            '56468f6991c348029c6bba403b444607-2cc7a802-0cc9-4c56-a5c7-539f55b73f11-6967',
        ],
        flightControls: {
            client_event: {
                flight: 'mini-ana-client-event',
                rate: 5,
            },
            client_verbose: {
                flight: 'mini-ana-client-verbose',
                rate: 1,
            },
            client_network_request: {
                flight: 'mini-ana-client-network-request',
                rate: 1,
            },
            client_error: {
                flight: 'mini-ana-client-error',
            },
        },
        qosDatapointNames: [
            'MailComposeNew',
            'MailComposeReplyAll',
            'MailComposeReply,',
            'MailComposeForward',
            'MailComposeSend',
            'LoadAccountOption',
            'SaveQuickActionsOption',
            'LoadSignatureOption',
        ],
    };
}
